import { lazy } from "react";

const MaterialOmitted = lazy(() => import("./MaterialOmitted"));

/**
 * The Omitted Material Page.
 */
const MaterialOmittedConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "mantenedores/omitted-materials",
      element: <MaterialOmitted />,
    },
  ],
};

export default MaterialOmittedConfig;
